class TileDirection {

    static LEFT() {
        return { fx: -1, fy: 0, label: 'left' };
    }

    static UP() { 
        return { fx: 0, fy: -1, label: 'up' };
    }
    
    static RIGHT() {
        return { fx: 1, fy: 0, label: 'right' };
    }

    static DOWN() {
        return { fx: 0, fy: 1, label: 'down' };
    }

    static ROTATE(dir) {

        switch (dir.label) {

            case TileDirection.LEFT().label:
                return TileDirection.UP();

            case TileDirection.UP().label:
                return TileDirection.RIGHT();

            case TileDirection.RIGHT().label:
                return TileDirection.DOWN();

            case TileDirection.DOWN().label:
                return TileDirection.LEFT();

            default:
                console.error('Cannot rotate invalid TileDirection. Returned default value.');
                return TileDirection.LEFT();
        }
    }
}

export default TileDirection;


// WEBPACK FOOTER //
// ./src/TileDirection.jsx